import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-documents-multiselect-toolbar',
  templateUrl: './documents-multiselect-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslocoModule]
})
export class DocumentsMultiselectToolbarComponent {
  @Input() visible = false;

  @Output() downloadSelected = new EventEmitter<void>();
  @Output() deleteSelected = new EventEmitter<void>();
  @Output() cancelSelection = new EventEmitter<void>();
}
